class Callback {
    constructor(thisArg, method) {
        this._thisArg = thisArg;
        this._method = method;
    }
    equals(thisArg, method) {
        return this._thisArg === thisArg && this._method === method;
    }
    hasThisArg(thisArg) {
        return this._thisArg === thisArg;
    }
    //You can pass any arguments into call()
    invoke(...args) {
        this._method.apply(this._thisArg, args);
    }
}
class EventObject {
    constructor() {
        this._callbacks = new Array();
    }
    add(thisArg, method) {
        this._callbacks.push(new Callback(thisArg, method));
    }
    //This will remove the first callback that matches callback.
    remove(thisArg, method) {
        let callbackCount = this._callbacks.length;
        for (let callbackIndex = 0; callbackIndex < callbackCount; callbackIndex++) {
            if (this._callbacks[callbackIndex].equals(thisArg, method)) {
                this._callbacks.splice(callbackIndex, 1);
                return; //Only remove the first one!
            }
        }
    }
    //This will remove all callback associated with thisArg.
    removeAllWithThisArg(thisArg) {
        for (let callbackIndex = 0; callbackIndex < this._callbacks.length; callbackIndex++) {
            if (this._callbacks[callbackIndex].hasThisArg(thisArg)) {
                this._callbacks.splice(callbackIndex, 1);
                callbackIndex--;
            }
        }
    }
    clear() {
        this._callbacks.length = 0;
    }
    //Takes arbitrary argument array which will be passed onto the callback
    raise(...args) {
        for (let callbackIndex = 0; callbackIndex < this._callbacks.length; callbackIndex++) {
            this._callbacks[callbackIndex].invoke(...args);
        }
    }
}
export { EventObject };
